var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.gutterWrapper},[_c('MaskController',{class:[
      _vm.$style.gutterReversal,
      _vm.$style.harmonyShadow ],attrs:{"collection-presenter":_vm.collectionPresenter}},[_c('Collection',{ref:"CollectionPresenter",class:[
        _vm.$style.scroller,
        _vm.$style.overlaySrollArea,
        _vm.$style.invisibleScrollArea,
        _vm.$style.gutterScroller,

        _vm.alignmentClass,
        _vm.scrollSnapAlignClass ]},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }